<div class="form-row m-0">
	<div class="form-row position-relative w-100">
		<mat-form-field appearance="outline" class="input-noa w-100">
			<input
				type="text"
				placeholder="Select City"
				matInput
				[(ngModel)]="comuneLabel"
				[formControl]="comuneControl"
				[matAutocomplete]="comune"
			/>
			<mat-autocomplete #comune="matAutocomplete" (optionSelected)="emitComune($event.option.value)">
				<mat-option *ngFor="let option of comuniOptions | async" [value]="option">
					{{ option[1] }}
				</mat-option>
			</mat-autocomplete>
		</mat-form-field>
	</div>
</div>
